/* eslint-disable */
// @ts-nocheck
import { useState, useRef, useEffect } from 'react';
import { BlandWebClient } from 'bland-client-js-sdk';
import { useNavigate } from 'react-router';
import RecordRTC from 'recordrtc';
import axiosFileUpload from '@/utils/axiosFileUpload';
import { Button } from '../ui/button';

const WebAgent = ({ callId, internalAgentId, token }: { callId: string; internalAgentId: string; token: string }) => {
  const navigate = useNavigate();
  const [isCallActive, setIsCallActive] = useState(false);
  const blandClient = useRef<BlandWebClient | null>(null);
  const recorderRef = useRef<RecordRTC | null>(null);

  const startCall = async () => {
    if (!isCallActive) {
      try {
        const userStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const client = new BlandWebClient(internalAgentId, token);
        blandClient.current = client;

        await client.initConversation({
          sampleRate: 44100,
          callId: callId,
          customStream: userStream,
          enableUpdate: true,
        });

        const audioContext = client?.audioContext;
        const userSourceNode = audioContext.createMediaStreamSource(userStream);
        const destinationNode = audioContext.createMediaStreamDestination();
        userSourceNode.connect(destinationNode);
        client.audioNode.connect(destinationNode);
        const combinedStream = destinationNode.stream;

        // Configure RecordRTC for high-quality audio
        recorderRef.current = new RecordRTC(combinedStream, {
          type: 'audio',
          mimeType: 'audio/wav',
          recorderType: RecordRTC.StereoAudioRecorder,
          numberOfAudioChannels: 1,
          desiredSampRate: 44100,
          bufferSize: 16384,
        });

        recorderRef.current.startRecording();

        setIsCallActive(true);
      } catch (error) {
        console.error('Error starting call:', error);
      }
    }
  };

  const stopCall = async () => {
    if (isCallActive) {
      try {
        setIsCallActive(false);

        if (blandClient.current) {
          blandClient.current.stopConversation();
        }

        if (recorderRef.current) {
          await new Promise((resolve) => {
            recorderRef?.current?.stopRecording(async () => {
              try {
                const blob = recorderRef?.current?.getBlob();

                if (!blob) {
                  throw new Error('No recording blob');
                }

                const formData = new FormData();
                formData.append('audio_file', blob, 'recording.wav');

                const uploadResponse = await axiosFileUpload.put(`/v1/ingest/${callId}`, formData);

                if (!uploadResponse) {
                  throw new Error('Upload failed');
                }

                resolve(undefined);
                navigate(`/call_scenarios/${callId}`);
              } catch (error) {
                console.error('Error processing recording:', error);
                resolve(undefined);
              }
            });
          });
        }

        // Cleanup
        blandClient.current = null;
        recorderRef.current = null;
      } catch (error) {
        console.error('Error stopping call:', error);
      }
    }
  };

  useEffect(() => {
    startCall();
    return () => {
      stopCall();
    };
  }, []);

  return (
    <>
      <Button onClick={stopCall} variant={'destructive'} className="w-full">
        End Call
      </Button>
    </>
  );
};

export default WebAgent;
